<template>
  <Fragment>
    <v-card v-if="isSmall" class="pa-3 rounded-card card-shadow">
      <v-row dense>
        <v-col cols="12">
          <div class="d-flex justify-space-between align-center">
            <div>
              <small v-if="respostaProduto.cotacaoProduto.produto">
                (
                <px-span-tooltip
                  top
                  :text="respostaProduto.cotacaoProduto.produto.codigo"
                  tooltip="Código do item"/>
                )</small>
              <div class="body-1">
                <px-produto-descricao
                  :show-codigo="false"
                  :show-descricao-with-tooltip="false"
                  :especificacao="respostaProduto.cotacaoProduto.especificacaoProduto"
                  :produto="respostaProduto.cotacaoProduto.produto"/>
                <px-cotacao-produto-detalhes-popover
                  :cotacao-produto="respostaProduto.cotacaoProduto"
                  :id-fornecedor="idFornecedor"/>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row dense v-if="codigoReferencia" class="caption">
        <v-col cols="12">
          Código fornecedor: {{ codigoReferencia }}
        </v-col>
      </v-row>
      <v-row dense v-if="respostaProduto.cotacaoProduto.finalidadeCompra">
        <v-col cols="12">
          Finalidade:&nbsp;
          <px-finalidade-compra-value
            :finalidade-compra="respostaProduto.cotacaoProduto.finalidadeCompra"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          Quantidade:&nbsp;
          {{
            respostaProduto.cotacaoProduto.quantidade
              | number(getCurrencyFormat(
              respostaProduto.cotacaoProduto.produto.casasDecimais))
          }}
          {{ respostaProduto.cotacaoProduto.unidadeMedida.descricao }}
        </v-col>
      </v-row>
      <template v-if="!isRespondida">
        <v-row dense no-gutters>
          <v-col cols="12">
            <px-situacao-resposta-produto-chip
              close
              :situacao="respostaProduto.situacao"
              @close="onCloseSituacao(respostaProduto)"/>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row dense>
          <v-col cols="12">
            <px-input-currency
              dense
              ref="precoUnitario"
              :label="labelPreco"
              class="required rounded-tag-small"
              :options="configuracaoMoeda"
              :error="$v.respostaProduto.precoUnitario.$error"
              :precision="respostaProduto.cotacaoProduto.produto.casasDecimais"
              @blur="$v.respostaProduto.precoUnitario.$touch()"
              v-model="respostaProduto.precoUnitario"/>
          </v-col>
        </v-row>
        <v-row dense v-if="!isMei">
          <v-col cols="12">
            <px-input-percentage
              dense
              label="ICMS"
              class="required rounded-tag-small"
              ref="icms"
              :error="$v.respostaProduto.impostos.icms.$error"
              @blur="$v.respostaProduto.impostos.icms.$touch()"
              v-model="respostaProduto.impostos.icms">
              <template v-slot:append>
                <px-resposta-cadastro-produto-replicar-preco
                  @click="onClickReplicarImposto(respostaProduto, 'icms')"
                  tooltip-text="Replicar imposto para os outros produtos"/>
              </template>
            </px-input-percentage>
          </v-col>
        </v-row>
        <v-row dense v-if="!isMei">
          <v-col cols="12">
            <px-input-percentage
              dense
              label="IPI"
              class="required rounded-tag-small"
              ref="ipi"
              :error="$v.respostaProduto.impostos.ipi.$error"
              @blur="$v.respostaProduto.impostos.ipi.$touch()"
              v-model="respostaProduto.impostos.ipi">
              <template v-slot:append>
                <px-resposta-cadastro-produto-replicar-preco
                  @click="onClickReplicarImposto(respostaProduto, 'ipi')"
                  tooltip-text="Replicar imposto para os outros produtos"/>
              </template>
            </px-input-percentage>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              dense
              outlined
              auto-grow
              hide-details
              class="mb-3 rounded-tag-small"
              label="Especificação"
              rows="1"
              v-model="respostaProduto.especificacaoProduto"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <px-anexo badge-color="primary"
                      v-model="respostaProduto.arquivos"
                      :max="3"
                      top
                      :bottom="false"
                      :upload-base-path="uploadFilePath"
                      @loading="onFileLoading">
            </px-anexo>
            <px-recusar-produto @change="onChangeSituacao" class="d-inline-block">
              <template v-slot:activator="{ on }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: onTooltip }">
                    <v-btn color="error" icon v-on="{...on, ...onTooltip}">
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Recusar produto</span>
                </v-tooltip>
              </template>
            </px-recusar-produto>
          </v-col>
        </v-row>
      </template>
    </v-card>
    <!-- Table row layout para telas maiores -->
    <template v-else>
      <tr class="no-hover">
        <td rowspan="2">
          <small v-if="respostaProduto.cotacaoProduto.produto">
            (
            <px-span-tooltip
              top
              :text="respostaProduto.cotacaoProduto.produto.codigo"
              tooltip="Código do item"/>
            )</small>
          <span class="body-1">
          <px-produto-descricao
            :show-codigo="false"
            :show-descricao-with-tooltip="false"
            :especificacao="respostaProduto.cotacaoProduto.especificacaoProduto"
            :produto="respostaProduto.cotacaoProduto.produto"/>
          <px-cotacao-produto-detalhes-popover
            :cotacao-produto="respostaProduto.cotacaoProduto"
            :id-fornecedor="idFornecedor"/>
        </span>
          <p v-if="codigoReferencia" class="caption">
            Código fornecedor: {{ codigoReferencia }}
          </p>
          <p v-if="respostaProduto.cotacaoProduto.finalidadeCompra">
            Finalidade:&nbsp;
            <px-finalidade-compra-value
              :finalidade-compra="respostaProduto.cotacaoProduto.finalidadeCompra"/>
          </p>
        </td>
        <td rowspan="2" class="body-1">
          {{
            respostaProduto.cotacaoProduto.quantidade
              | number(getCurrencyFormat(
              respostaProduto.cotacaoProduto.produto.casasDecimais))
          }}
          {{ respostaProduto.cotacaoProduto.unidadeMedida.descricao }}
        </td>
        <td colspan="4" style="border-bottom: none;" v-if="!isRespondida">
          <px-situacao-resposta-produto-chip
            close
            :situacao="respostaProduto.situacao"
            @close="onCloseSituacao(respostaProduto)"/>
        </td>
        <template v-if="isRespondivel">
          <td class="px-1" style="height: 60px; border-bottom: none;">
            <px-input-currency
              dense
              ref="preco"
              :label="labelPreco"
              class="required rounded-tag-small"
              :options="configuracaoMoeda"
              :error="$v.respostaProduto.precoUnitario.$error"
              :precision="respostaProduto.cotacaoProduto.produto.casasDecimais"
              @blur="$v.respostaProduto.precoUnitario.$touch()"
              v-model="respostaProduto.precoUnitario"/>
          </td>
          <td class="px-1" style="border-bottom: none;" v-if="!isMei">
            <px-input-percentage
              dense
              label="ICMS"
              class="required rounded-tag-small"
              ref="icms"
              :error="$v.respostaProduto.impostos.icms.$error"
              @blur="$v.respostaProduto.impostos.icms.$touch()"
              v-model="respostaProduto.impostos.icms">
              <template v-slot:append>
                <px-resposta-cadastro-produto-replicar-preco
                  @click="onClickReplicarImposto(respostaProduto, 'icms')"
                  tooltip-text="Replicar imposto para os outros produtos"/>
              </template>
            </px-input-percentage>
          </td>
          <td class="px-1" style="border-bottom: none;" v-if="!isMei">
            <px-input-percentage
              dense
              label="IPI"
              class="required rounded-tag-small"
              ref="ipi"
              :error="$v.respostaProduto.impostos.ipi.$error"
              @blur="$v.respostaProduto.impostos.ipi.$touch()"
              v-model="respostaProduto.impostos.ipi">
              <template v-slot:append>
                <px-resposta-cadastro-produto-replicar-preco
                  @click="onClickReplicarImposto(respostaProduto, 'ipi')"
                  tooltip-text="Replicar imposto para os outros produtos"/>
              </template>
            </px-input-percentage>
          </td>
          <td rowspan="2" class="text-center" style="width: 150px">
            <px-anexo badge-color="primary"
                      v-model="respostaProduto.arquivos"
                      :max="3"
                      top
                      :bottom="false"
                      :upload-base-path="uploadFilePath"
                      @loading="onFileLoading">
            </px-anexo>
            <px-recusar-produto @change="onChangeSituacao" class="d-inline-block">
              <template v-slot:activator="{ on }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: onTooltip }">
                    <v-btn color="error" icon v-on="{...on, ...onTooltip}">
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Recusar produto</span>
                </v-tooltip>
              </template>
            </px-recusar-produto>
          </td>
        </template>
      </tr>
      <tr class="no-hover">
        <td v-if="!isRespondida" class="default-table-border" :colspan="isMei ? 2 : 4"></td>
        <td v-if="isRespondivel" class="px-1 default-table-border" :colspan="isMei ? 1 : 3">
          <v-textarea
            dense
            outlined
            auto-grow
            hide-details
            class="mb-3 rounded-tag-small"
            label="Especificação"
            rows="1"
            v-model="respostaProduto.especificacaoProduto"
          />
        </td>
      </tr>
    </template>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';
import validationMixin from '@/mixins/validation-mixin';
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import { required } from 'vuelidate/lib/validators';
import { CasaDecimalUtils, FornecedorProdutoUtils } from 'px-components';
import { mapGetters } from 'vuex';
import moedaMixin from '@/mixins/moeda-mixin';
import CotacaoProdutoDetalhesPopover from './CotacaoProdutoDetalhesPopover.vue';
import RespostaCadastroProdutoReplicarPreco from './RespostaCadastroProdutoReplicarPreco.vue';

export default {
  mixins: [validationMixin, moedaMixin],
  props: {
    respostaProduto: {
      type: Object,
      required: true,
    },
    moeda: {
      type: String,
    },
    idFornecedor: {
      type: [String, Number],
      default: null,
    },
    isMei: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      cotacaoId: 'cotacaoId',
    }),
    uploadFilePath() {
      return `external/${this.cotacaoId}/files`;
    },
    labelPreco() {
      return `Preço por ${this.respostaProduto.cotacaoProduto.unidadeMedida.descricao}`;
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    isRespondivel() {
      return this.isRespondida;
    },
    isRespondida() {
      return this.respostaProduto.situacao
        === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    codigoReferencia() {
      const { fornecedoresProduto } = this.respostaProduto.cotacaoProduto.produto;
      return FornecedorProdutoUtils.getCodigoReferenciaFornecedor(
        fornecedoresProduto,
        this.idFornecedor,
      );
    },
  },
  methods: {
    onChangeSituacao(situacao) {
      this.respostaProduto.situacao = situacao.key;
    },
    onCloseSituacao() {
      this.respostaProduto.situacao = SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    onClickReplicarImposto(respostaProduto, tipoImposto) {
      this.$emit('replicar-imposto', respostaProduto, tipoImposto);
    },
    onFileLoading(loading) {
      this.respostaProduto.$$hasFileLoading = loading;
    },
  },
  validations() {
    if (!this.isRespondivel) {
      return {};
    }
    return {
      respostaProduto: {
        precoUnitario: {
          required,
          minValue: value => value > 0,
        },
        impostos: {
          icms: {
            required,
            minValue: value => value >= 0,
          },
          ipi: {
            required,
            minValue: value => value >= 0,
          },
        },
      },
    };
  },
  components: {
    pxCotacaoProdutoDetalhesPopover: CotacaoProdutoDetalhesPopover,
    pxRespostaCadastroProdutoReplicarPreco: RespostaCadastroProdutoReplicarPreco,
    Fragment,
  },
};
</script>
